import { createContext } from 'react';

import { MagicSearchContextValue } from './magic-search.type';

export const MagicSearchContext = createContext<MagicSearchContextValue>({
  isAvailable: false,
  openMagicSearch: () => {},
});
